import R from 'ramda';
import dispatch from './dispatch';

const matchesSku = ({ sku, swatch }) => (
  R.or(
    R.propEq('sku', sku, swatch),
    R.propEq('sku', sku.substring(1, 14), swatch),
  )
);

export const trackBuyEvent = ({
  currencyCode,
  sku,
  productTitle,
  subcategoryTitle,
  name,
  link: retailerUrl,
  price,
  productSwatch,
  productQuantity,
  brand,
  list,
  eventName = 'buyNow',
}) => {
  const swatches = R.prop('swatches', productSwatch);

  const productVariant = R.filter(
    swatch => matchesSku({ sku, swatch }),
    swatches,
  );

  const detail = {
    eventInfo: {
      eventAction: 'Buy Now',
      eventName,
      eventType: 'userEvent',
      currency: currencyCode.toLowerCase(),
      productInfo: {
        sku,
        name: productTitle.toLowerCase(),
        quantity: productQuantity,
        type: subcategoryTitle.toLowerCase(),
        itemPrice: price,
        brand,
        list,
        variant: {
          size: '',
          colour: R.ifElse(
            R.path([0, 'skuColor']),
            R.compose(
              R.toLower,
              R.path([0, 'itemName']),
            ),
            () => '',
          )(productVariant),
        },
      },
      retailerInfo: {
        retailerName: name.toLowerCase(),
        retailerUrl,
        price: price.replace(/[^\d.,]+/g, ''),
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const trackSelectedShadeEvent = ({
  shade,
  sku,
  name,
  type,
  location = 'swatch dropdown',
}) => {
  const eventName = 'shadeSelected';

  const detail = {
    eventInfo: {
      eventAction: 'Shade Selected',
      eventName,
      eventType: 'userEvent',
      productInfo: {
        shade,
        sku,
        name,
        type,
        location,
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const trackShopAllShadesEvent = ({
  title = '',
  subcategory = '',
  action = '',
}) => {
  const eventName = 'shopAllShades';

  const detail = {
    eventInfo: {
      eventAction: action.toLowerCase(),
      eventName,
      eventType: 'userEvent',
      productInfo: {
        action: action.toLowerCase(),
        productname: title.toLowerCase(),
        type: subcategory.toLowerCase(),
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const trackViewMoreEvent = ({
  title = '',
  subcategory = '',
  action = '',
}) => {
  const eventName = 'viewMore';

  const detail = {
    eventInfo: {
      eventAction: action.toLowerCase(),
      eventName,
      eventType: 'userEvent',
      productInfo: {
        action: action.toLowerCase(),
        productname: title.toLowerCase(),
        type: subcategory.toLowerCase(),
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};
